import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import { MdEmail, MdLocationPin, MdPhone } from "react-icons/md";
import { IoLogoWhatsapp, IoGlobeOutline } from "react-icons/io5";

const QUICK_LINKS = [
  { label: "Home", item: "home" },
  { label: "About Us", item: "about_us" },
  { label: "Products & Services", item: "services" },
  { label: "Contact Us", item: "contact_us" },
];

const CONTACT_INFO = {
  email: "info@thaihk.tz",
  phones: [
    {
      label: "+255 717 861 061",
      tel: "tel:+255717861061",
      whatsapp: "https://wa.me/255717861061",
    },
  ],
  offices: [
    "Bandari House Kurasini, Bandari Street, Dar es Salaam, Tanzania",
    "House No 328, Uraa Road, Michael Uroki Ward, Hai - Kilimanjaro, Tanzania",
  ],
};

export default function Footer() {
  const { navTo } = useContext(AppContext);

  return (
    <footer className="footer-modern pt-5 pb-3" style={{ background: "#131516", color: "#cbd5e1" }}>
      <div className="container">
        <div className="row g-4 mb-4">
          
          {/* Brand Column */}
          <div className="col-lg-4 col-md-12 mt-5">
            <h5 className="text-white font-bold mb-3">THAI H&K TRADING <br /> COMPANY LIMITED</h5>
            <p className="small leading-relaxed mb-3">
              Specializing in the processing and export of high-quality Tanzanian meat, fish, 
              and premium produce for international markets.
            </p>
            <div className="p-2 px-3 rounded-2" style={{ background: "rgba(249, 201, 108, 0.1)", borderLeft: "3px solid #f9c96c" }}>
              <span className="small font-semi-bold text-white" style={{ color: "#f9c96c" }}>
                Global Export Standards & Quality
              </span>
            </div>
          </div>

          {/* Navigation Column */}
          <div className="col-lg-3 col-md-4 col-6 mt-5">
            <h6 className="text-white font-bold mb-4 text-uppercase small tracking-wider">Quick Links</h6>
            <nav className="d-flex flex-column gap-2">
              {QUICK_LINKS.map((link) => (
                <button 
                  key={link.item} 
                  onClick={() => navTo({ item: link.item })} 
                  className="footer-link text-start btn btn-link p-0 text-decoration-none"
                  style={{ color: "inherit", fontSize: "0.95rem" }}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact Column */}
          <div className="col-lg-5 col-md-8 mt-5">
            <h6 className="text-white font-bold mb-4 text-uppercase small tracking-wider">Get In Touch</h6>
            <div className="d-flex flex-column gap-3">
              
              {/* Office Locations */}
              {CONTACT_INFO.offices.map((address, idx) => (
                <div key={idx} className="d-flex align-items-start gap-2">
                  <MdLocationPin className="mt-1 flex-shrink-0" style={{ color: "#f9c96c" }} size={18} />
                  <span className="small">{address}</span>
                </div>
              ))}

              {/* Communication Links */}
              <div className="row g-2">
                {CONTACT_INFO.phones.map((phone) => (
                  <div key={phone.label} className="col-12 d-flex align-items-center gap-3">
                    <div className="d-flex align-items-center gap-2">
                      <MdPhone style={{ color: "#f9c96c" }} size={18} />
                      <a href={phone.tel} className="small text-decoration-none text-white fw-bold">
                        {phone.label}
                      </a>
                    </div>
                    <a
                      href={phone.whatsapp}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm py-0 px-2 d-flex align-items-center gap-1"
                      style={{ background: "#25D366", color: "#fff", fontSize: "0.75rem", borderRadius: "4px" }}
                    >
                      <IoLogoWhatsapp size={14} /> WhatsApp
                    </a>
                  </div>
                ))}
              </div>

              <div className="d-flex flex-wrap gap-4">
                <div className="d-flex align-items-center gap-2">
                  <MdEmail style={{ color: "#f9c96c" }} size={18} />
                  <a href={`mailto:${CONTACT_INFO.email}`} className="small text-decoration-none text-white">
                    {CONTACT_INFO.email}
                  </a>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="small text-white">{CONTACT_INFO.website}</span>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <hr style={{ borderColor: "rgba(255,255,255,0.1)" }} />
        <div className="footer-bottom pt-2 d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
          <p className="mb-0 x-small text-light">
            &copy; {getCurrentYear()} <strong>THAI H&K TRADING COMPANY LIMITED</strong>
          </p>
          <p className="mb-0 x-small text-light">
            Designed by{" "}
            <a href="https://werenium.com" target="_blank" rel="noreferrer" className="text-decoration-none" style={{ color: "#f9c96c" }}>
              Werenium Technologies
            </a>
          </p>
        </div>
      </div>

      <style>{`
        .footer-link:hover { color: #f9c96c !important; transform: translateX(5px); transition: all 0.3s ease; }
        .x-small { font-size: 0.8rem; }
      `}</style>
    </footer>
  );
}